import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Close, LocationOn } from "@mui/icons-material";

const LocationCardHeader = ({
  selectedLocation,
  selectedComponent,
  onCancel,
  t,
}) => {
  return (
    <>
      <Box sx={{ display: "flex", mb: 2, alignItems: "flex-start" }}>
        {/* Image/icon left side */}
        <Box sx={{ mr: 2, mt: 0.5 }}>
          {selectedLocation.previewUrl && selectedComponent ? (
            <img
              src={selectedLocation.previewUrl}
              alt="Preview"
              style={{
                width: "56px",
                height: "56px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          ) : (
            <Box
              sx={{
                width: 56,
                height: 56,
                bgcolor: "#f1f3f4", // Google's background gray
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#5f6368",
              }}
            >
              <LocationOn fontSize="medium" />
            </Box>
          )}
        </Box>

        {/* Location info */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" component="div">
            {selectedLocation?.address?.road ||
              selectedLocation?.address?.location ||
              t("mapWithComponents.selectedLocation")}
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mt: 0.5 }}>
            {selectedLocation?.address?.postcode || ""}{" "}
            {selectedLocation?.address?.city || ""}
          </Typography>
        </Box>

        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            padding: "4px",
            color: "#5f6368",
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>

      {/* Divider after header */}
      <Box sx={{ height: "1px", bgcolor: "#e8eaed", mb: 2 }} />
    </>
  );
};

export default LocationCardHeader;
